<template>
    <div id="start-view">
        <div class="ctr">
            <div class="logo">
                <img alt="Kliniken patientsystem" src="@/assets/kliniken-logo.svg" />
            </div>

            <div class="login">
                <LoginFrame />
            </div>
        </div>

        <div class="support">
            <div class="heading">
                <p>Kontakta vår support så hjälper vi dig</p>
            </div>
            <div class="text">
                <p>Öppettider vardagar 07:00 - 17:00 (lunchstängt 11:45 – 12:30). Vi rekommenderar mejl för icke brådskande ärenden – då får du hjälp av rätt expert. Behöver du akut hjälp, ring oss.</p>
            </div>
        </div>

        <div class="kontakt-info">
            <div class="info">
                <img alt="Kliniken telefon-logo" src="@/assets/phone_circle.svg" />
                <div class="text">
                    <p><strong>Telefon för akuta ärenden</strong></p>
                    <p><a href="tel:0701650690"><u>0701-650 690</u></a></p>
                </div>
            </div>
            <div class="info">
                <img alt="Kliniken mail-logo" src="@/assets/mail_circle.svg" />
                <div class="text">
                    <p><strong>E-post för övriga ärenden</strong></p>
                    <p><a href="mailto:support@kliniken3.se"><u>support@kliniken3.se</u></a></p>
                </div>
            </div>
            <div class="info">
                <img alt="Kliniken info-web-logo" src="@/assets/info_web_circle.svg" />
                <div class="text">
                    <p><strong>Mer information Klinikens webbplats</strong></p>
                    <p><a href="https://www.kliniken3.se"><u>kliniken3.se</u></a></p>
                </div>
            </div>
        </div>
        <div class="bg-image">
            <img alt="bg-image" src="@/assets/kliniken_sidfot.svg" />
        </div>

        <FooterDivider />
        <div class="bottom">
                <div class="bottom-content">
                    <div class="information">
                        <p class="heading">Kontaktinformation</p>
                        <div class="text">
                            <p>Kliniken Patientsystem AB</p>
                            <p>Roslagsgatan 24b</p>
                            <p>113 55 Stockholm</p>
                            <p>info@kliniksystem.se</p>
                            <p>0701-650 690</p>
                            <p><a href="https://www.kliniken3.se" ><u>kliniken3.se</u></a></p>
                        </div>
                    </div>
                    <div class="information">
                        <p class="heading">Systeminformation</p>
                        <div class="text">
                            <p>Kliniken</p>
                            <p><strong>UDI-DI</strong> {{ udiDi }}</p>
                            <p><strong>Version/UDI-PI</strong> {{ udiPi }}</p>
                        </div>
                    </div>
                    <div class="information">
                        <p class="heading">Kliniken</p>
                        <div class="text">
                            <p>Journalsystemet som låter dig fokusera på patienten.</p>
                            <br>
                            <p>Skapat tillsammans med vårdpersonal för att göra vardagen enklare, säkrare och mer effektiv.</p>
                        </div>
                    </div>
                </div>
        </div>
        <div class="ce-logga">
            <img alt="Kliniken CE-logo" src="@/assets/ce-marke.svg" />
            <p>Kliniken journalsystem är CE-märkt och godkänt som medicinteknisk produkt</p>
        </div>

    </div>
</template>

<script setup>
    import LoginFrame from "@/components/Auth/LoginFrame.vue";
    import { useStore } from "@/store";
    import { computed } from "vue";
    import FooterDivider from "@/components/FooterDivider.vue";

    const store = useStore();

    const udiDi = computed(() => store.state.systemData?.udiDi);
    const udiPi = computed(() => store.state.systemData?.systemVersion);
</script>

<style lang="scss">
    @import "@/style/variables";

    $max-width: 1210px;
    $container-padding-x: 15px;

    $footer-heading-font-size: 16px;
    $footer-heading-line-height: 22px;


    $footer-text-font-size: 16px;
    $footer-text-line-height: 22px;

    .ctr {
        max-width: $max-width;
        margin-left: auto;
        margin-right: auto;
    }

    #start-view {
        background-color: #228AAF;
        padding-top: 45px;

        .logo {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                height: 70px;
                width: 194px;
            }
        }

        .login {
            display: flex;
            justify-content: center;
            margin-top: 45px;
        }

        .blurbs {
            display: flex;
            gap: 56px;
            margin-top: 80px;

            div {
                flex: 1;
                min-width: 0;
                color: white;
            }

            .left .heading {
                font-size: 38px;
                line-height: 50px;
                padding-right: 113px;
            }
            .right .text {
                font-size: 20px;
                line-height: 30px;
            }
        }
        .support {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            flex-flow: row wrap;
            max-height: 102px;
            padding-top: 30px;
            padding-bottom: 100px;
            padding-left: 10px;
            padding-right: 10px;
            gap: 40px;
            color: white;

            .heading {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 700px;
                height: 34px;
                font-size: 30px;
                line-height: 34px;
            }

            .text {
                width: 724px;
                height: 55px;
            }
        }

        .kontakt-info {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 70px;
            padding-top: 60px;
            color: white;

            .info {
                padding-top: 4px;
                padding-bottom: 150px;
                padding-left: 5px;
                padding-right: 5px;
                height: 96px;
                width: 350px;
            }

            .text {
                a:link, a:visited {
                    color: white;
                }
                a:hover, a:active {
                    color: white;
                }
            }
        }

        .bg-image {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .ce-logga {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
        }

       .bottom {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 60px;
            padding-bottom: 48px;
            background-color: #014F71;

            .bottom-content {
                display: flex;
                justify-content: center;
                gap: 200px;
            }

            .information{
                max-width: 350px;
                max-height: 170px;
                padding-left: 10px;
                padding-right: 10px;


                a:link, a:visited * {
                    color: white ;
                }
                a:hover, a:active * {
                    color: white;
                }
                .heading {
                    font-size: $footer-heading-font-size;
                    line-height: $footer-heading-line-height;
                    margin-bottom: 10px;
                    color: white;
                }
                 .text {
                    font-size: $footer-text-font-size;
                    line-height: $footer-text-line-height;
                    margin-bottom: 10px;
                    color: white;
                }
            }
        }

        .ce-logga {
            background-color: #014F71;
            color: white;
            padding-bottom: 48px;
        }
        .footer-divider {
            height: 220px;
        }
    @media screen and (max-width: 992px) {
            .bottom .bottom-content {
                display: grid;
                grid-gap: 2rem;
            }
        }
    }
</style>
